import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('localization/country');
  }

  languages = async () => {
    return api.get(this.buildUrl('language'));
  };
}

export default new API();
